import { mapState } from 'vuex'
/** revisar `store/search.js` si hay cambios en el min y max */
const FALLBACK_RANGES = {
  MXN: { min: 1000, max: 120000 },
  COP: { min: 150000, max: 25000000 },
  USD: { min: 40, max: 6000 },
}

const FALLBACK_RANGES_UNIT = {
  MXN: { min: 300, max: 8000 },
  COP: { min: 60000, max: 1600000 },
  USD: { min: 15, max: 400 },
}

export default {
  computed: {
    ...mapState('settings', ['currency']),
    ...mapState('settings', {
      exchangeRate: 'exchange_rate',
    }),
    ...mapState('search', {
      searchValues: 'values',
    }),
    currentRate() {
      const exchange = this.exchangeRate.find((t) => t.code === this.currency)

      return exchange ? exchange.rate : 0
    },
    currentPow() {
      let pow = 10

      switch (this.currency) {
        case 'MXN':
          pow = 100
          break
        case 'COP':
          pow = 100000
          break
        default:
          break
      }

      return pow
    },
    min() {
      if (this.currentRate === 0) {
        return this.filterBy === 'price'
          ? FALLBACK_RANGES[this.currency].min
          : FALLBACK_RANGES_UNIT[this.currency].min
      } else {
        const min =
          this.filterBy === 'price'
            ? this.searchValues.price.min
            : this.searchValues.price_unit.min

        return (
          Math.floor((min * this.currentRate) / this.currentPow) *
          this.currentPow
        )
      }
    },
    max() {
      if (this.currentRate === 0) {
        return this.filterBy === 'price'
          ? FALLBACK_RANGES[this.currency].max
          : FALLBACK_RANGES_UNIT[this.currency].max
      } else {
        const max =
          this.filterBy === 'price'
            ? this.searchValues.price.max
            : this.searchValues.price_unit.max

        return (
          Math.round((max * this.currentRate) / this.currentPow) *
          this.currentPow
        )
      }
    },
  },
  data() {
    return {
      filterBy: 'price',
      options: ['price', 'price_per_unit'],
    }
  },
}
